module.exports = __webpack_public_path__ + "static/pic01-6988586cd67f36c324d6c1ddf41b05c8.jpg";